import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLoginMutation } from "../redux/api/authApi";
import { selectIsAuthenticated } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  
  // RTK Query mutation hook
  const [login, { isLoading, error }] = useLoginMutation();
  
  // Check if user becomes authenticated
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [wasLoggedIn, setWasLoggedIn] = useState(isAuthenticated);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login({ email, password }).unwrap();
      // Success is handled by the useEffect below
    } catch (err) {
      // Error is automatically available via the error state from useLoginMutation
      console.error('Login failed:', err);
    }
  };

  // Navigate to dashboard on successful login
  useEffect(() => {
    if (!wasLoggedIn && isAuthenticated) {
      setWasLoggedIn(true);
      setEmail("");
      setPassword("");
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate, wasLoggedIn]);

  // Extract error message for display
  const errorMessage = error?.data?.error || error?.data?.message || error?.error || null;

  return (
    <div className="login-page d-flex justify-content-center align-items-center vh-100">
      <form
        onSubmit={handleSubmit}
        className="w-50 p-4 border rounded bg-light"
      >
        <h2 className="mb-4">Login</h2>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            data-testid="email"
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            data-testid="password"
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={isLoading}
        >
          {isLoading ? "Logging in..." : "Login"}
        </button>
        {errorMessage && <p className="error text-danger mt-3">{errorMessage}</p>}
      </form>
    </div>
  );
};

export default LoginPage;
